<template>
  <el-container class="box">
  <el-aside width="200px">   
     <el-menu
      default-active="2"
      class="el-menu-vertical-demo"
     @select="handleMenuSelect"
      background-color="#545c64"
      text-color="#fff"
      :router='true'
      active-text-color="#ffd04b">
      <el-menu-item index="首页" :route="menu.menu[0].name" v-if="role !=='teacher'">
        <i class="el-icon-menu"></i>
        <span slot="title">{{menu.menu[0].name}}</span>
      </el-menu-item>
      <el-submenu :index="item.name" v-for="(item,index) in menu.menu" :key="index"   v-if="item.child">
          <template slot="title" >
          <i class="el-icon-location"></i>
          <span>{{item.name}}</span>
        </template>
        <el-menu-item-group v-for="(child,inDex) in item.child" :key="inDex" v-if="role ==='teacher' && (child ==='词库管理'|| child === '启动页管理' || child === '文章管理')?false:true " >
          <el-menu-item :index="child" :route="child" >{{child}}</el-menu-item>
        </el-menu-item-group>
       
   
      
      </el-submenu>
    </el-menu>
    
    </el-aside>
  <el-container>
    <el-header class="header_bread">
         <el-breadcrumb separator="/" >
            <el-breadcrumb-item :to="{ path: '/首页' }" v-if="role !='teacher'">首页</el-breadcrumb-item>
            <!-- <el-breadcrumb-item>{{currentPath}}</el-breadcrumb-item> -->
            <el-breadcrumb-item v-if="list==='内容管理'||list==='成绩查询'||list==='学生管理'||list==='首页'||list==='全局设置'?false:true" v-for="list in currentPath" :to="list==='内容管理'?{name:'词库管理'}:{ name: list}" >{{list}}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-button  class="getOut" type="primary" @click="getOut()">退出<i class="el-icon-upload el-icon--right"></i></el-button>
    </el-header>
   
    <el-main class="main">

    
         <router-view class="body" :key="$route.fullPath"></router-view>
    
      
    </el-main>
    <!-- <el-footer>Footer</el-footer> -->
  </el-container>
</el-container>
</template>
<script>
//  import Topmenu from '@/components/Topmenu.vue'
import {mapState} from 'vuex'
export default {
    components: {
    // Topmenu
  },
    computed:{
...mapState(["menu"]),
 },
   data () {
        return {
            height:'',
            currentPath:'',
            paths:'',
            role:''
        }
    },
    methods: {
      handleMenuSelect(index,indexPath){
        // console.log(index,indexPath[1])
        // this.currentPath = '首页'
        this.currentPath = indexPath
      },
      getOut(){
        sessionStorage.removeItem('token')
        this.$router.push('/')
      }
    },
    watch:{
     $route(to,from,next){
    // eslint-disable-next-line no-console
     this.paths =to.name
    console.log(to);
    console.log(this.currentPath)
        //  this.currentPath=to.name
    
   
    }
  
    },
    mounted () {
      this.height = document.body.clientHeight-61
      this.width = document.body.clientWidth-250
      // eslint-disable-next-line no-console
      console.log(this.menu)
         this.paths = this.$route.path 
      // eslint-disable-next-line no-console
        this.role =JSON.parse( sessionStorage.getItem('role')).role
         console.log(this.role)
    }
}
</script>
<style lang="scss" scoped>
.box{
    height: 100%;
    .el-menu-vertical-demo{
        height: 100%;
    }
}
.el-header{
  height: 100px;
    padding: 40px;
    display: flex;
    align-items: center;
    .el-breadcrumb{
      flex: 1;
    }
    .getOut{
      height: 40px;
    }
}
.main{
    padding: 0;
    .body{
        padding: 20px;
    }
}

// .box{
//      position: relative;
//      overflow: hidden;
//     .main{
//         position: absolute;
//         top: 61px;
//         left: 250px;
//         padding: 5%;

//     }
// }
// // .el-menu-demo{
// //   height: 61px;
// // }
// .el-menu-vertical-demo{
//   width: 250px;
//   height: 100%;
// }
</style>
